<template>
  <div class="pa-4">
    <div class="d-flex flex-row-reverse">
      <v-row align="center">
        <v-col class="py-0" cols="auto">
          <v-tabs slider-size="4" background-color="transparent" v-model="verifyTab">
            <v-tab
              v-for="type in verifyTabType"
              :key="type.key"
              :class="['title', $globalStyle.tabColor]"
              v-text="type.value"
              @click="$refs.unselectAll.click()"
            ></v-tab>
          </v-tabs>
        </v-col>
        <v-spacer class="py-0"></v-spacer>
        <v-col class="py-0" cols="6" md="5" lg="4" xl="3">
          <v-text-field
            v-model="search"
            background-color="white"
            outlined
            dense
            single-line
            rounded
            placeholder="搜尋名字、電話..."
            hide-details
            prepend-inner-icon="mdi-magnify"
          ></v-text-field>
        </v-col>
      </v-row>
    </div>
    <v-row>
      <v-col cols="auto" class="pb-0">
        <v-card tile outlined style="top:1px;z-index:1;border-bottom: 0px" v-if="verifyTab === 0">
          <v-tabs v-model="roleTab" color="cyan" hide-slider background-color="grey lighten-2">
            <v-tab
              v-for="(type, index) in roleTabType"
              :key="type.key"
              :class="{ 'subtitle-1': true, white: roleTab === index }"
              v-text="type.value"
              @click="$refs.unselectAll.click()"
            ></v-tab>
          </v-tabs>
        </v-card>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto">
        <v-scroll-y-transition group>
          <template v-if="selectRow.length > 0">
            <v-btn
              depressed
              color="orange"
              key="verify"
              dark
              class="mx-2"
              v-if="verifyTabType[verifyTab].key === 'unverify'"
              @click="verifyUser"
            >
              <span class="subtitle-1">通過驗證</span>
            </v-btn>

            <v-btn
              depressed
              color="error"
              key="delete"
              @click="$refs.deleteConfirmDialog.showForDeleteUser(selectRow)"
            >
              <span class="subtitle-1">刪除</span>
            </v-btn>
          </template>
          <template v-else>
            <v-btn
              depressed
              :color="$classStyle.addBtn"
              key="add"
              dark
              class="mx-2"
              @click="$refs.dialogCreateAccount.showDialog()"
            >
              <v-icon left>mdi-plus</v-icon>
              <span class="subtitle-1">新增</span>
            </v-btn>
          </template>
        </v-scroll-y-transition>
      </v-col>
    </v-row>
    <v-card outlined>
      <v-data-table
        :class="[$globalStyle['manage-table'], $globalStyle['cross-row']]"
        show-select
        :headers="headers"
        :items="tableItems"
        hide-default-footer
        item-key="_id"
        :items-per-page="itemPerPage"
        :page="page"
        :search="search"
        @input="selected => (selectRow = selected)"
        @current-items="items => (currentItems = items)"
        @click:row="item => goProfile(item)"
      >
        <!--  @click:row="item => goProfile(item)" -->
        <template v-slot:top>
          <v-toolbar flat color="white">
            <span v-text="tableHint" :class="['body-2', $globalStyle.tableHeaderColor]"></span>
            <v-spacer></v-spacer>
            <div class="d-inline-flex">
              <base-pagination v-model="page" :length="Math.ceil(tableItems.length / itemPerPage)"></base-pagination>
            </div>
          </v-toolbar>
        </template>
        <template v-slot:header.data-table-select="{ props, on }">
          <div ref="unselectAll" @click="on.input(false)"></div>
          <v-checkbox
            color="cyan"
            hide-details
            class="mt-0"
            @click.stop="headerCheckBoxClick(on,props)"
            v-bind="props"
            v-on="on"
          ></v-checkbox>
        </template>
        <template v-slot:item.data-table-select="{ isSelected, select,item }">
          <v-checkbox
            v-if="item.permission!=='role_admin'"
            color="cyan"
            hide-details
            :input-value="isSelected"
            @click.stop="select(!isSelected)"
            class="mt-0"
          ></v-checkbox>
          <div :ref="`checkbox_${item.phone}_true`" @click.stop="select(true)"></div>
          <div :ref="`checkbox_${item.phone}_false`" @click.stop="select(false)"></div>
        </template>
        <template v-slot:item.name="{ item }" @click="goProfile(item)">
          <span v-text="item.name" class="pointer black--text"></span>
        </template>
        <template v-slot:item.phone="{ item }">
          <span v-text="item.phone" class="pointer black--text"></span>
        </template>
        <template v-slot:item.permission="{ item }">
          <span v-text="$common.parsePermission(item.permission)" class="pointer black--text"></span>
        </template>
        <template v-slot:item.clinic="{ item }">
          <span v-text="item.clinic" class="pointer black--text"></span>
        </template>
        <template v-slot:item.info="{ item }">
          <span v-text="item.info" class="pointer black--text"></span>
        </template>
        <template v-slot:no-data>無資料</template>
      </v-data-table>
    </v-card>
    <v-snackbar
      top
      color="success text-center"
      class="subtitle-1"
      :timeout="$spec.snakebar_timeout"
      v-model="verifySnackbar"
      vertical
    >
      <span>驗證成功</span>
    </v-snackbar>
    <dialog-delete-confirm ref="deleteConfirmDialog" @done="deleteUserFinish"></dialog-delete-confirm>
    <dialog-create-account ref="dialogCreateAccount" @created="getAll()"></dialog-create-account>
    <socket-io :focusEvent="focusEvent" @onReceive="getAll"></socket-io>
  </div>
</template>

<style scoped>
.v-snack--top {
  top: 40px;
}
</style>
<script>
import DialogDeleteConfirm from "../common/DialogDeleteConfirm";
import DialogCreateAccount from "./DialogCreateAccount";
import SocketIo from "../common/SocketIo";
import BasePagination from "../common/BasePagination";

export default {
  components: {
    DialogDeleteConfirm,
    DialogCreateAccount,
    SocketIo,
    BasePagination
  },
  data: () => ({
    focusEvent: ["newRegister"],
    page: 1,
    itemPerPage: 10,
    selectRow: [],
    currentItems: [],
    verifyTabType: [
      {
        key: "verified",
        value: "已驗證"
      },
      {
        key: "unverify",
        value: "待驗證"
      }
    ],
    roleTabType: [
      {
        key: "role_user",
        value: "一般用戶"
      },
      {
        key: "role_staff",
        value: "員工"
      }
    ],
    roleTab: 0,
    verifyTab: 0,
    headers: [
      {
        text: "名字",
        value: "name",
        class: ["subtitle-2", "font-weight-bold", "tableHeaderColor"]
      },
      {
        text: "電話",
        value: "phone",
        class: ["subtitle-2", "font-weight-bold", "tableHeaderColor"]
      },
      {
        text: "權限",
        value: "permission",
        class: ["subtitle-2", "font-weight-bold", "tableHeaderColor"]
      },
      {
        text: "群組",
        value: "clinic",
        class: ["subtitle-2", "font-weight-bold", "tableHeaderColor"]
      },
      {
        text: "備註",
        value: "info",
        class: ["subtitle-2", "font-weight-bold", "tableHeaderColor"]
      }
    ],
    allUserItems: [],
    verifySnackbar: false,
    search: ""
  }),
  computed: {
    tableHint() {
      if (this.selectRow.length > 0) {
        return `已選取${this.selectRow.length}個帳號`;
      } else {
        let start = (this.page - 1) * this.itemPerPage + 1;
        let end = start + this.currentItems.length - 1;
        return `${start}-${end}筆, 共${this.tableItems.length}筆資料`;
      }
    },
    tableItems() {
      let verifyType = this.verifyTabType[this.verifyTab].key;
      let roleType = this.roleTabType[this.roleTab].key;

      if (verifyType === "verified") {
        if (roleType === "role_user") {
          return this.allUserItems.filter(item => {
            return item.permission === "role_user";
          });
        } else {
          return this.allUserItems.filter(item => {
            return (
              item.permission === "role_staff" ||
              item.permission === "role_admin"
            );
          });
        }
      } else {
        return this.allUserItems.filter(item => {
          return item.permission === "role_tbc";
        });
      }
    }
  },
  methods: {
    async getAll() {
      let response = await this.$ajax.get(
        `${this.$config.apiUrl}/${this.$my.getClinic()}/users/0`
      );
      this.allUserItems = response.data;
    },
    async verifyUser() {
      let verifyType = this.verifyTabType[this.verifyTab].key;
      let thisVm = this;
      if (verifyType === "unverify" && this.selectRow.length > 0) {
        for (let user of this.selectRow) {
          await thisVm.updatePermissionToRoleUser(user.phone);
        }
        this.verifySnackbar = true;
        this.getAll();
        this.$refs.unselectAll.click();
      }
    },
    async updatePermissionToRoleUser(phone) {
      await this.$ajax.put(
        `${this.$config.apiUrl}/${this.$my.getClinic()}/permission/${phone}`,
        { permission: "role_tbc", permissionNew: "role_user" }
      );
    },
    goProfile(item) {
      if (this.verifyTabType[this.verifyTab].key === "verified") {
        this.$router.push({ path: `/accountManage/profile/${item.phone}` });
      }
    },
    deleteUserFinish() {
      this.$refs.unselectAll.click();
      this.getAll();
    },
    headerCheckBoxClick(on, props) {
      // @click.stop="on.input(!props.value)"
      let noAdmin = this.currentItems.every(function(user) {
        return user.permission !== "role_admin";
      });

      if (noAdmin) {
        on.input(!props.value);
      } else {
        let value = this.selectRow.length === 0;
        this.currentItems.forEach(user => {
          if (user.permission !== "role_admin") {
            this.$refs[`checkbox_${user.phone}_${value}`].click();
          }
        });
      }
    }
  },
  mounted() {
    this.getAll();
  }
};
</script>
